import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const CopyIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.6666 10.9376L16.6666 5.50003C16.6666 3.84317 15.3235 2.50002 13.6666 2.50003L8.22912 2.5001M11.6666 17.5001L6.04163 17.5001C5.00609 17.5001 4.16663 16.6606 4.16663 15.6251L4.16663 7.5001C4.16663 6.46456 5.00609 5.6251 6.04162 5.6251L11.6666 5.62509C12.7022 5.62509 13.5416 6.46456 13.5416 7.50009L13.5416 15.6251C13.5416 16.6606 12.7022 17.5001 11.6666 17.5001Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </BaseIcon>
  );
};

CopyIcon.displayName = 'CopyIcon';
